import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import authApi from '@/api/auth'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    authUser: null
  },
  getters: {
    authenticated: state => state.authUser !== null,
    accessToken: state => (state.authUser !== null ? state.authUser.access_token : null),
    permissionAllowCode: state => (state.authUser !== null ? state.authUser.permission_allow_code : null),
    userType: state => (state.authUser !== null ? state.authUser.user_type : null),
    permissions: state => (state.authUser !== null ? state.authUser.permissions : null),
    defautlBranch: state => (state.authUser !== null ? state.authUser.defautlBranch : null),
    limitStringShow: state => text => {
      if (text != null) {
        let article = text.replace(/(<([^>]+)>)/gi, '')
        return article.length > 60 ? article.substring(0, 60) + '...' : article
      }
      return ''
    }
  },
  mutations: {
    DRAWER_STATE(state, value) {
      state.drawer.model = value
    },
    MINI_DRAWER(state) {
      state.drawer.mini = !state.drawer.mini
    },
    setAuthUser(state, authUser) {
      if (authUser) {
        state.authUser = Object.assign(
          {},
          {
            user_name: authUser.user_name,
            // token_type: authUser.token_type,
            // refresh_token: authUser.refresh_token,
            // expires_in: authUser.expires_in,
            access_token: authUser.access_token,
            permission_allow_code: authUser.permission_allow_code,
            user_type: authUser.user_type,
            permissions: authUser.permissions,
            default_branch: authUser.default_branch
          }
        )

        localStorage.setItem('authUser', JSON.stringify(state.authUser))
      } else {
        state.authUser = null
        localStorage.clear()
      }
    }
  },
  actions: {
    init({ commit }) {
      const authUser = JSON.parse(localStorage.getItem('authUser'))
      if (authUser) {
        commit('setAuthUser', authUser)
      }
    },
    login({ commit }, formData) {
      return authApi.login(formData).then(response => {
        commit('setAuthUser', response.data)

        return Promise.resolve(response)
      })
    },
    logout({ commit }) {
      commit('setAuthUser', null)
    }
  },
  modules
})

store.dispatch('init')

export default store
